// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/toolbar","rootFixed":"toolbar-m__rootFixed__ZdCap"};